module.exports = __webpack_public_path__ + "static/media/DSC00574-56_Small.bc830a74.jpg";